import { Button, Dialog, DialogActions, DialogContent } from "@mui/material";
import { Component } from "react";
import DialogTitleWithCloseButton from "../../../../components/DialogTitleWithCloseButton";
import EditableTextbox from "../../../../components/EditableTextbox";
import request from "../../../../request";
import swal from "sweetalert";
import { errorToast } from "../../../../toast";
import AttachmentInput from "../../../../components/AttachmentInput";
import { hideLoading, showLoading } from "../../../../loading";

export default class Restructure extends Component {

   state = {
      annual_rate: '',
      write_off: 0,
      tenure_extension: 0,
      canSubmit: false,
      contract: null
   }

   canSubmit = () => {
      const { annual_rate, write_off, tenure_extension, contract} = this.state;
      const canSubmit = contract && ((annual_rate && annual_rate !== this.props.loan.annual_rate) || write_off || tenure_extension);
      return canSubmit;
   }

   submit = async () => {

      const { annual_rate, write_off, tenure_extension, contract } = this.state;

      // validate
      if (!contract) return errorToast("Please select the new contract");

      if (write_off && write_off < 0)
         return errorToast("Write off amount cannot be negative");

      if (tenure_extension && tenure_extension < 0)
         return errorToast("Tenure extension cannot be negative");

      // create payload
      const data = {
         contract
      }

      if (annual_rate && annual_rate !== this.props.loan.annual_rate)
         data.annual_rate = parseFloat(annual_rate);
      if (write_off)
         data.write_off = parseFloat(write_off);
      if (tenure_extension)
         data.tenure_extension = parseInt(tenure_extension);

      if (Object.keys(data).length === 0) return;

      // submit
      try {

         showLoading("Restructuring loan...");

         const res = await request.post(`/api/finance/loans/${this.props.loan._id}/restructure`, data);
         this.props.onClose(res.data);
         swal("Success", "Loan restructured successfully", "success");

      } catch (err) {
         swal("Error", err.message, "error");
      } finally {
         hideLoading();
      }

   }

   componentDidMount() {
      this.setState({
         annual_rate: this.props.loan.annual_rate
      });
   }

   render() {

      const canSubmit = this.canSubmit();

      return <Dialog open>
         <DialogTitleWithCloseButton onClose={() => this.props.onClose()}>
            Restructure Loan
         </DialogTitleWithCloseButton>

         <DialogContent dividers>
            <div className="py-4 flex flex-col gap-8 max-w-full w-[300px]">

               <AttachmentInput
                  label="New Contract"
                  name={this.state.contract?.name}
                  onChange={contract => this.setState({ contract })}
               />

               <EditableTextbox
                  label="Annual Rate"
                  type="number"
                  value={this.state.annual_rate}
                  defaultValue={this.props.loan.annual_rate}
                  onChange={annual_rate => this.setState({ annual_rate })}
               />

               <EditableTextbox
                  label="Write Off"
                  type="number"
                  value={this.state.write_off}
                  defaultValue={0}
                  onChange={write_off => this.setState({ write_off })}
               />

               <EditableTextbox
                  label="Tenure Extension"
                  type="number"
                  value={this.state.tenure_extension}
                  defaultValue={0}
                  onChange={tenure_extension => this.setState({ tenure_extension })}
               />
               
            </div>
         </DialogContent>

         <DialogActions>
            <Button onClick={this.submit} variant="contained" size="small" disabled={!canSubmit}>
               Restructure
            </Button>
         </DialogActions>
      </Dialog>
   }
}